import * as React from "react";

import { cn } from "@/lib/utils";
import {
  customElementAttributeMappers,
  setCustomElementMetadata,
} from "@/lib/customElements";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input transition bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

setCustomElementMetadata({
  component: Input,
  tagName: "raes-input",
  observedAttributes: {
    name: customElementAttributeMappers.string,
    placeholder: customElementAttributeMappers.string,
    required: customElementAttributeMappers.boolean,
    disabled: customElementAttributeMappers.boolean,
    type: customElementAttributeMappers.string,
    value: (value: string, elem?: HTMLElement) => ({
      ...(elem as HTMLInputElement)?.type === "number"
          ? customElementAttributeMappers.number(value)
          : customElementAttributeMappers.string(value),
      prop: "defaultValue",
    }),
  },
});

export { Input };
